import api from "api";

const eventSectors = {
    get: (eventId) => {
        return api().get(`/events/${eventId}/sectors`)
    },
};

export default eventSectors;  